import { request } from '@/shared/api/request'

export const getAll = (data, params, cache = false) => {
	return request({ url: 'contract/page', method: 'POST', data: data, params: params, withCredentials: true, cache: cache })
}

export const checkDocuments = (data, params) => {
	return request({ url: `contract/free/checkDoc/${data}`, method: 'GET', params: params})
}

export const checkDocumentsSl = (data, params) => {
	return request({ url: `contract/free/checkSl/${data}`, method: 'GET', params: params})
}